var $panel = $('#headerGlobalNav');
var $button = $('#headerGlobalNavClose');
/**
 * 関数定義
 */
// 初期化処理

var init = function init() {
  var panelId = $panel.attr('id');
  var buttonId = $button.attr('id'); // デフォルトの属性を設定

  $panel.attr({
    'aria-hidden': 'false',
    'aria-labelledby': buttonId
  });
  $button.attr({
    'aria-expanded': 'true',
    'aria-controls': panelId
  }); // クッキーの有無チェックと存在する場合の処理

  var cookieData = document.cookie.split(';');
  cookieData.forEach(function (value) {
    // 該当するクッキーの値に応じて初期状態を変更
    if (value.trim() === 'gnav=close') {
      $button.attr('aria-expanded', 'false');
      $panel.attr('aria-hidden', 'true');
    } else if (value.trim() === 'gnav=open') {
      $button.attr('aria-expanded', 'true');
      $panel.attr('aria-hidden', 'false');
    }
  });
}; // 表示切替


var switchDisplay = function switchDisplay(e) {
  // ステートに応じてボタンとパネルの属性値を変更
  if ($button.attr('aria-expanded') === 'false') {
    // 閉じている
    // クリックしたボタンと該当するパネルを開く
    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false');
    document.cookie = 'gnav=open; path=/; max-age=15552000;';
  } else {
    // 開いている
    $button.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true');
    document.cookie = 'gnav=close; path=/; max-age=15552000;';
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
};
/**
 * 初期化処理
 */


init();
/**
 * イベント設定
 */

$button.on('click', switchDisplay);